import React, { createRef, useContext, useEffect, useRef, useState } from "react";
import { Sidebar, Menu, MenuItem, SubMenu, menuClasses } from "react-pro-sidebar";
import Logo from "./Logo";
import { menuItems, integrationItems, menuItems2 } from "./menuItems";
import classes from "./Menu.module.scss";
import { NavLink, useNavigate, useHref } from "react-router-dom";
import { MenuContext } from "../../store/menu_context";
import { OrgIdContext, ClientTypes } from "../../store/orgId_context";
import HelpIcon from '@mui/icons-material/Help';
import { OverlayTrigger, Placeholder, Tooltip } from "react-bootstrap";
import { UserUIStateContext } from "../../store/userUIStateContext";
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import background2 from "../../assets/Image20250820144130.png"
import MenuItemInterval from "./MenuItemInterval";
import { useTranslation } from 'react-i18next';
import { tx } from '../../lib/ddd/ddd';
import { ThemeContext } from "../../store/ThemeContext";
import EmailIcon from '@mui/icons-material/Email';
import { NotificationManager} from 'react-notifications';
import { useQuery } from '@tanstack/react-query';
import { DDD } from '../../lib/ddd/ddd';

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const isAbsoluteUrl = (url) => {
  return /^https?:\/\//.test(url);
};

const SideMenu = () => {
  const {preview, theme} = useContext(ThemeContext);
  const { isMenuCollapsed, setMenuFunctionsHandler } = useContext(MenuContext);
  const { isTransformer , isIntegrator, ISVCustomer, AccCustomer, getRoles, integrationNotFinished, clientType, isLoaded, isMaintainer, sessionInfo, connectionKey, connectionKeyMode, integrationDevice } = useContext(OrgIdContext);
  const {integrationWizardFinished, integrationData, clientWizardFinished} = useContext(UserUIStateContext);
  const roles = getRoles();
  const navigate = useNavigate();
  const [openNodesArr, setOpenNodesArr] =  useState();
  const [opened, setOpened] = useState({});
  const nodesRef = useRef([...Array(20)].map( () => createRef()));
  //const {theme} = useContext(ThemeContext);

  const { t } = useTranslation();
  const forceTranslation = () =>{
    t("Dashboard");
    t("Administration");
    t("My company");
    t("Setup");
    t("Profile");
    t("Services");
    t("My Customers");
    t("Invoice Flow Control");
    t("Integration");
    t("Init");
    t("Services");
    t("Distribution channels");
    t("Delivery channels");
    t("PDF customization");
    t("Pre-made plugins");
    t("Operation mode");
    t("Received");
    t('E-Reporting');
    t('Live/test mode');
  }
  
  let availableBasePaths = ["integration", "administration", "flow", "mycompany"];
  let pathNames = useHref("/")?.replace(/^\/|\/$/g, '').split("/") || [];
  let basePath = pathNames.length > 0 && pathNames[0].toLocaleLowerCase();
  const isBasePath = availableBasePaths.indexOf(basePath) >= 0;
  
  const { data: docupathExtractionData } = useQuery({
    queryKey: ["serverFlag_docupathExtraction"],
    queryFn: async () => {
      const ddd = new DDD(apiRequestAddress);
      return ddd.Rpc_ExecuteMethod("EUeInvoices.GetSettingValue", { VarName: "DocupathExtraction" });
    },
    enabled: !!connectionKey,
    staleTime: Infinity,
  });
  const { data: mistralExtractionData } = useQuery({
    queryKey: ["serverFlag_mistralExtraction"],
    queryFn: async () => {
      const ddd = new DDD(apiRequestAddress);
      return ddd.Rpc_ExecuteMethod("EUeInvoices.GetSettingValue", { VarName: "MistralExtraction" });
    },
    enabled: !!connectionKey,
    staleTime: Infinity,
  });
  const isSettingTrue = (data) => data?.result?.Result === true || data?.result?.Result === "true";
  const serverFlags = {
    docupathExtraction: isSettingTrue(docupathExtractionData) || isSettingTrue(mistralExtractionData),
  };

  let counter= -1;

  const drawTreeRec = (item, index, depth) =>{
    if(item.serverFlag && !serverFlags[item.serverFlag])
      return null;
    let contains = roles.some(i => item.roles.includes(i)) || item.roles.includes("all");
    if(contains && item?.countries?.length > 0)
      contains = item?.countries?.includes(sessionInfo?.Extended?.CountryCodeSC__CountryCode) || item?.countries?.includes("all");
    if(item.notRoles){
      if(roles.some(i=> item.notRoles.includes(i))) return null;
    }
    if(item.roles.includes("maintainer") && isMaintainer)
      contains=true;
    let defaultOpen = false;
    if(isBasePath && depth === 0)
      defaultOpen = true;

    if(!contains)
      return null;
    
    let color="transparent";
    if(depth===0)
      color = "rgba(255,255,255,.07)";

    if(item.hasOwnProperty("children")){
      counter++;
      return(<React.Fragment key={`sidemenu-frag-${index}-${item.itemName}`}>
      <div className={classes["submenu-wrapper"]}>
        <SubMenu 
        label={tx(t(item.itemName))}
        style={{color : "white"}} 
        icon={item.icon}
        key={`sidemenu-${index}-${item.itemName}`} 
        defaultOpen = {defaultOpen}
        ref = {nodesRef.current[counter]}
        onClick={() => onSubmenuOpen(item.itemName)}
        open={opened[item.itemName]}>
          <div style={{backgroundColor:color}} key={`sidemenumain-div-${index}-${item.itemName}`}>
          {item.children.map((i, ix) => {
            return drawTreeRec(i, ix, depth+1);
          })}
          </div>
        </SubMenu>
        </div>
      </React.Fragment>)
    }else{
      if(item.url === "/sent-integration-invoices")
        return <MenuItemInterval key={`sidemenu-interval-${index}-${item.itemName}`} index={index} item={item} parentRef={nodesRef.current[counter]}/>
      return(
        <MenuItem
          key={`sidemenu-item-${index}-${item.itemName}`}
          component={
            isAbsoluteUrl(item.url) ?
            <a href={item.url} target="_blank" rel="noopener noreferrer" />:
            <NavLink to={item.url} />
          }
          style={{color : "white"}} 
          icon={item.icon}
          suffix = {getItemSuffix(item)}
        >
          {tx(t(item.itemName))}
        </MenuItem>
      )
    }
  }

  const onSubmenuOpen = (uniqueId) => {
    setOpened({...opened, [uniqueId] : opened[uniqueId] ? false : true})
  }
  useEffect(() => {
    //console.log(opened);
  }, [opened])

  const getItemSuffix = (item) => {
    if(!item)
      return null;

    if(integrationData?.integrationWizardCompleted !== true && item.url === "/integration-wizard")
      return <UnpublishedIcon style={{fontSize:"1rem"}}/>
    if(clientWizardFinished !== true && item.url === "/client-init")
      return <UnpublishedIcon  style={{fontSize:"1rem"}}/>
    if(integrationData?.integrationWizardCompleted ===true && item.url === "/integration-wizard")
      return <CheckCircleIcon style={{fontSize:"1rem", color:"#18b918"}}/>
    if(clientWizardFinished === true && item.url === "/client-init")
      return <CheckCircleIcon  style={{fontSize:"1rem", color:"#18b918"}}/>
    
    return null;
  }

  useEffect(() => {
    var funct = {};
    funct.openNodeToPath = openNodeToPath;
    setMenuFunctionsHandler(funct);
  }, [opened]);

  const openNodeToPath = (path) =>{
    if(!path) return;

    let interval = 0;
    path.forEach((txt) => {
      nodesRef.current.forEach(node => {
        if(!node || !node.current) return;
        if(node.current.children[0].innerText === txt && opened[txt] !== true)
          setTimeout(() => {node.current.children[0].click()}, interval);
      });
      interval += 700;
    });
    
    //nodesRef.current["administration"].click();
  }

  const copyReferCode = () => {;
    const link = `${window.location.origin}/sign-up?refercode=${sessionInfo?.Extended?.RefCode||"unknown"}`;
    navigator.clipboard.writeText(link);
    NotificationManager.success(t("Copied"), null, 5000);
  }
//ps-menu-label
  return (
    <>
    
    <div className={`${classes["sidebar-wrapper"]} sidebar-div`}>
    <Sidebar
    image={theme ? undefined : background2}
    //backgroundColor="rgba(0,86,131,.9)"
    backgroundColor={theme ? "tansparent" : getComputedStyle(document.body).getPropertyValue('--menu-background-color').trim()}
    //backgroundColor={"tansparent"}
    collapsed={isMenuCollapsed}
    collapsedWidth="80px"
    width="270px"
    className={`${classes.sidebar} sidebar-main`}
  >
      <Menu
        className="pt-4"
        menuItemStyles={{
          label : {
            "&" : {
              whiteSpace: "wrap"
            }
          },
          button: {
            "&.active": {
              //opacity: .8,
              //background: "#2c6e90",
              //backgroundColor: "#0077A8",
              textDecoration:"underline",
              fontStyle:"italic"
              //textShadow: "2px 2px #2c6e90",
              //borderBottom:"1px solid"
            },
            /*"&:hover": {
              opacity: 0.8,
              backgroundColor: "#0077A8",
            },*/
          },
        }}
      >
      <Logo />
      {/* <div className={classes["stampwrapper"]}>
        <div className={classes["stamped"]}>
          {connectionKey}
          <CopyBtn style={{color:"white", fill:"white", marginLeft:"0.3rem", transform:"scale(0.7)"}}/>
        </div>
      </div> */}
      {false && !isMenuCollapsed && (isTransformer || isIntegrator || clientType===ClientTypes.ISV || clientType===ClientTypes.AccService) && integrationNotFinished &&
      <div className={classes["howtoStart"]} onClick={() => navigate("/quickstart")}>
        <span className={classes["howtoStartIcon"]}>
          <svg width="25" height="25" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M21.2993 27.0826L29.1526 38.05C29.1759 38.0824 29.2242 38.0824 29.2474 38.05L47.9007 12L59.2571 27.8595C62.3415 32.167 64 37.332 64 42.6298V44C64 57.2548 53.2548 68 40 68C26.7452 68 16 57.2548 16 44V42.6298C16 37.332 17.6585 32.167 20.7429 27.8595L21.2993 27.0826Z" fill="#EB5757" />
            <path fillRule="evenodd" clipRule="evenodd" d="M23.6285 41.1088L29.1526 48.8234C29.1759 48.8558 29.2242 48.8558 29.2474 48.8234L46.0001 25.4277L53.4105 34.9319C55.6071 37.749 56.7999 41.2189 56.7999 44.7912C56.7999 53.6466 49.6212 60.8254 40.7657 60.8254H39.2342C30.3787 60.8254 23.2 53.6466 23.2 44.7912C23.2 43.5434 23.3455 42.3081 23.6285 41.1088Z" fill="#F2C94C" />
          </svg>
        </span>
        {t("Quickstart")}
      </div>}

      {!isLoaded &&
        <div style={{marginTop: "2rem"}}>
          <Placeholder animation="glow">
            <Placeholder as={MenuItem}/>
            <p></p>
            <Placeholder as={MenuItem} />
            <p></p>
            <Placeholder as={MenuItem}/>
          </Placeholder>
        </div>
      }

      {isLoaded && menuItems2.map((item, index) => {
        if(isBasePath && item.basePath !== basePath)
          return null;
        if(!isBasePath && item.onlyForBasePath === true)
          return null;
        let contains = roles.some(i => item.roles.includes(i)) || item.roles.includes("all");
        if(contains && item?.countries?.length > 0)
          contains = item?.countries?.includes(sessionInfo?.Extended?.CountryCodeSC__CountryCode) || item?.countries?.includes("all");
        if(item.roles.includes("maintainer") && isMaintainer)
          contains=true;
        if(contains){
          return drawTreeRec(item, index, 0);
        }
      })}
      </Menu>
    </Sidebar>
    <div className={isMenuCollapsed ? classes["bottomHelpCollapsed"] : classes["bottomHelp"]} style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
      {/* {(isTransformer || isIntegrator || clientType===ClientTypes.ISV || clientType===ClientTypes.AccService || clientType===ClientTypes.Company) && <OverlayTrigger placement="top" overlay={<Tooltip>{t("Go to quickstart")}</Tooltip>}>
          <NavLink to="/quickstart">
            <svg width="25" height="25" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M21.2993 27.0826L29.1526 38.05C29.1759 38.0824 29.2242 38.0824 29.2474 38.05L47.9007 12L59.2571 27.8595C62.3415 32.167 64 37.332 64 42.6298V44C64 57.2548 53.2548 68 40 68C26.7452 68 16 57.2548 16 44V42.6298C16 37.332 17.6585 32.167 20.7429 27.8595L21.2993 27.0826Z" fill="#ffffff" />
            <path fillRule="evenodd" clipRule="evenodd" d="M23.6285 41.1088L29.1526 48.8234C29.1759 48.8558 29.2242 48.8558 29.2474 48.8234L46.0001 25.4277L53.4105 34.9319C55.6071 37.749 56.7999 41.2189 56.7999 44.7912C56.7999 53.6466 49.6212 60.8254 40.7657 60.8254H39.2342C30.3787 60.8254 23.2 53.6466 23.2 44.7912C23.2 43.5434 23.3455 42.3081 23.6285 41.1088Z" fill="#ffffff" />
            </svg>
          </NavLink>
      </OverlayTrigger>} */}
      {/* <OverlayTrigger placement="top" overlay={<Tooltip>{t("Open assistance guide")}</Tooltip>}>
        <HelpIcon style={{cursor:"pointer"}}/>
      </OverlayTrigger> */}
      {!theme && <OverlayTrigger placement="top" overlay={<Tooltip>{t("Refer a company")}</Tooltip>}>
        <div className={isMenuCollapsed ? classes["referButtonCollapsed"] : classes["referButton"]} onClick={copyReferCode}>
          <EmailIcon style={{cursor:"pointer"}}/>
          {!isMenuCollapsed && <><span style={{marginLeft:"0.5rem"}}>{t("Refer")}</span></>}
        </div>
      </OverlayTrigger>}
    </div>  
    </div>
    </>
  )
/*
  return (
    <Sidebar
      backgroundColor="#005683"
      color="red"
      collapsed={isMenuCollapsed}
      collapsedWidth="80px"
      className={classes.sidebar}
    >
      <Menu
        className="pt-4"
        menuItemStyles={{
          button: {
            "&.active": {
              opacity: 0.8,
              background: "#004569",
            },
            "&:hover": {
              opacity: 0.8,
              backgroundColor: "#0077A8",
              // background: "orange",
            },
          },
        }}
      >
        <Logo />
        {menuItems.map((item, index) => {
          let contains = roles.some(i => item.roles.includes(i)) || item.roles.includes("all");
          if(!contains)
            return;
          return (
            <MenuItem
              key={`sidemenu-item-${index}`}
              component={<NavLink to={item.url} />}
              style={{ color: "white" }}
              icon={item.icon}
            >
              {tx(item.itemName)}
            </MenuItem>
          );
        })}
        {(isIntegrator || isTransformer) && 
        <span
          className={classes.integration}
          style={
            !isMenuCollapsed ? { color: "white" } : { color: "transparent" }
          }
        >
          Integration
        </span>}
        {(isIntegrator || isTransformer) && integrationItems.map((item, index) => {
          let contains = roles.some(i => item.roles.includes(i)) || item.roles.includes("all");
          if(!contains)
            return;
          return (
            <MenuItem
              key={`integration-item-${index}`}
              component={<NavLink to={item.url} />}
              style={{ color: "white" }}
              icon={item.icon}
            >
              {tx(item.itemName)}
            </MenuItem>
          );
          
        })}
      </Menu>
    </Sidebar>
  );
*/
};

export default SideMenu;
